import * as Yup from "yup";

import { MarginAccountDetailsValues } from "./MarginAccountDetailsSearch";

export const ALPHANUMERIC = /^[0-9a-zA-Z]+$/;

const marginSearchBarValidation: Yup.SchemaOf<MarginAccountDetailsValues> =
  Yup.object().shape({
    accountNumber: Yup.string()
      .max(8, "Requires 7 or 8 characters")
      .test(
        "accountNumber has 0 or minimum length",
        "Requires 7 or 8 characters",
        (value = "") => {
          if (value.length === 0) {
            return true;
          }
          return value.length >= 7;
        }
      )
      .test({
        name: "alphanumeric",
        message: "Alphanumeric characters only",
        test: str => {
          if (!str) return true;
          return ALPHANUMERIC.test(str);
        },
      })
      .required("Required"),
  });

export default marginSearchBarValidation;
